import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { EvaluationIconStyled } from 'components/patterns/Icon/IconsStyled'
import { Icon } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const StyledIcon = styled(Icon)`
  &&&& {
    > path {
      fill: ${themeColor('featureSimulatedValueResetIcon')}};
    }
    :hover path {
      fill: ${themeColor('featureSimulatedValueResetIcon')}};
    }
  }
`

export const MarginRightIcon = styled(Icon)`
  margin-right: 4px;
`

export const formFieldLayout = css`
  .form-field {
    flex: 0 1 auto;
  }
`

export const InputRow = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;
  ${StyledIcon} {
    margin-left: 6px;
  }

  ${formFieldLayout}
  &&&& .form-field .ant-select {
    width: 100%;
  }
`

export const ConditionRow = styled.div`
  color: ${themeColor('inputFontColor')};
  font-size: ${themeColor('inputDefaultLabelFontSize')};
  line-height: 18px;
  margin-bottom: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  > p {
    margin: 0;
  }
  ${EvaluationIconStyled} {
    margin-left: 8px;
  }
  && .eval-icon,
  && .edge-eval-icon {
    margin-left: 0;
    margin-right: 4px;
  }
  .timer-display {
    margin-left: 16px;
    margin-right: 8px;
  }
`

export const ListLabel = styled(ConditionRow.withComponent('label'))`
  font-weight: bold;
`

export const StyledImg = styled.span`
  line-height: 16px;
  svg {
    height: 16px;
  }
`
